import React, { useState, useRef, useEffect } from "react";
import { QRCode } from "react-qrcode-logo";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
// import Snackbar from "../../../common/snackbar/components/snackbar";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Card,
  CardContent,
  CardHeader,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
} from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  RadioGroup,
  Radio,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Footer from "../Home/components/footer";
import Nav_bar from "../Home/Container/navCon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

const CustomQRCode = (props) => {
  const [openLogin, setOpenLogin] = useState(true);
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [qrValue, setQrValue] = useState("");
  const [qrSize, setQrSize] = useState(300);
  const [fgColor, setFgColor] = useState("#000000");
  const [bgColor, setBgColor] = useState("#FFFFFF");
  const [eyeColor, setEyeColor] = useState([
    { outer: "#000000", inner: "#000000" },
    { outer: "#000000", inner: "#000000" },
    { outer: "#000000", inner: "#000000" },
  ]);
  const [eyeRadius, setEyeRadius] = useState([
    { outer: 10, inner: 5 },
    { outer: 10, inner: 5 },
    { outer: 10, inner: 5 },
  ]);
  const [qrStyle, setQrStyle] = useState("squares");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoWidth, setLogoWidth] = useState(50);
  const [logoHeight, setLogoHeight] = useState(50);
  const [clearLogoBg, setClearLogoBg] = useState(false);
  const [uniqueId] = useState(uuidv4());
  const [format, setFormat] = useState("");
  const [quality, setQuality] = useState("");
  const [qrType, setQrType] = useState("");
  const [redirectlink, setRedirectlink] = useState("");
  const qrCodeRef = useRef(null);
  const { qrCodeId } = useParams();
  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => setLogoUrl(reader.result);
    reader.readAsDataURL(file);
  };

  const handlePrint = async () => {
    if (!qrCodeRef.current) return;

    setTimeout(async () => {
      try {
        const scaleFactor = 3;
        const canvas = await html2canvas(qrCodeRef.current, {
          scale: scaleFactor,
          useCORS: true,
          logging: false,
        });
        const imageUrl = canvas.toDataURL("image/png", 1.0);

        const downloadLink = document.createElement("a");
        downloadLink.href = imageUrl;
        downloadLink.download = "updated_qrcode_hd.png";
        downloadLink.click();
      } catch (error) {
        console.error("Error saving QR code data:", error);
        alert("Failed to save QR code data.");
      }
    }, 100);
  };

  useEffect(() => {
    const fetchQRCodeData = async () => {
      const token = props.login.token;
      try {
        const payload = { qrCodeId };
        const response = await fetch(
          "https://qrcodebackend-458148834331.asia-south1.run.app/qrcode/viewQrById",
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              token,
            },
            body: JSON.stringify(payload),
          }
        );
        // console.log(response.status);

        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        // console.log(result);

        const data = result.data.result;

        if (data) {
          // console.log(data, 'Fetch data');
          setName(data.name);
          setEmail(data.email);
          setLink(data.link);
          setQrSize(300);
          setRedirectlink(data.redirectUrl);
          setQrSize(data.qrSize);
          setQrType(data.qrType);
          setFgColor(data.fgColor);
          setBgColor(data.bgColor);
          setEyeColor(data.eyeColor);
          setEyeRadius(data.eyeRadius);
          setQrStyle(data.qrStyle);
          setLogoUrl(data.logoUrl);
          setLogoWidth(data.logoWidth);
          setLogoHeight(data.logoHeight);
          setClearLogoBg(data.clearLogoBg);
        } else {
          console.log("Error: No data received from the server");
        }
      } catch (error) {
        console.error("Fetch API error:", error);
      }
    };

    fetchQRCodeData();
  }, [qrCodeId, props.login.token]);

  return (
    <Box>
      <Nav_bar />

      <Box
        sx={{
          minHeight: "60vh",
          padding: "20px",
          backgroundImage:
            "url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREqHQAhLVZ47Xyenj89hwLtgCHK_lGaEODMcAM741unQeyHEPD8rDUycMpi2hVyl4OkKE&usqp=CAU)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}>
        {/* <Snackbar
          open={this.props.snackbar?.response_received}
          close_snack_bar={this.props.close_snack_bar}
          message={this.props.snackbar?.message}
        /> */}
        <Link style={{ direction: "none" }} to="/qrcode">
          {" "}
          <Button variant="contained" color="secondary">
            <ArrowBackIcon /> Back
          </Button>
        </Link>
        <Grid
          container
          spacing={3}
          sx={{ maxWidth: 1200, margin: "auto", p: 2 }}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <CardHeader title="Custom QR Code Details" />
              <CardContent sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Full Name:
                    </Typography>
                    <Typography variant="h6">{name}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Email ID:
                    </Typography>
                    <Typography variant="h6">{email}</Typography>
                  </Grid>
                  {qrType !== "Static" && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" color="textSecondary">
                        Link:
                      </Typography>
                      <Typography variant="h6">{redirectlink}</Typography>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textSecondary">
                      QR Code Size:
                    </Typography>
                    <Typography variant="h6">{qrSize}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Foreground Color:
                    </Typography>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        backgroundColor: fgColor,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Background Color:
                    </Typography>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        backgroundColor: bgColor,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Eye Outer Color:
                    </Typography>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        backgroundColor: eyeColor[0].outer,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Eye Inner Color:
                    </Typography>
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        backgroundColor: eyeColor[0].inner,
                        borderRadius: "50%",
                        border: "1px solid #ccc",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Eye Outer Radius:
                    </Typography>
                    <Typography variant="h6">{eyeRadius[0].outer}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Eye Inner Radius:
                    </Typography>
                    <Typography variant="h6">{eyeRadius[0].inner}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textSecondary">
                      QR Style:
                    </Typography>
                    <Typography variant="h6">{qrStyle}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Clear Logo Background:
                    </Typography>
                    <Typography variant="h6">
                      {clearLogoBg ? "Yes" : "No"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Logo:
                    </Typography>
                    {logoUrl ? (
                      <Box
                        component="img"
                        src={logoUrl}
                        alt="Logo"
                        sx={{ width: 50, height: 50, borderRadius: "8px" }}
                      />
                    ) : (
                      <Typography variant="h6">No Logo</Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Logo Width:
                    </Typography>
                    <Typography variant="h6">{logoWidth}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1" color="textSecondary">
                      Logo Height:
                    </Typography>
                    <Typography variant="h6">{logoHeight}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          {link !== "" && (
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}>
                <CardHeader title="Generated QR Code" />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 2,
                    }}>
                    <Box id="qr-code" ref={qrCodeRef}>
                      <QRCode
                        value={link}
                        size={qrSize}
                        ecLevel="M"
                        eyeRadius={eyeRadius}
                        eyeColor={eyeColor}
                        qrStyle={qrStyle}
                        fgColor={fgColor}
                        bgColor={bgColor}
                        quietZone={10}
                        logoImage={logoUrl}
                        logoWidth={logoWidth}
                        logoHeight={logoHeight}
                        removeQrCodeBehindLogo={clearLogoBg}
                      />
                    </Box>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handlePrint}
                      startIcon={<DownloadIcon />}>
                      Download QR Code
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default CustomQRCode;
